
// @mui
import { IconButton } from '@mui/material';

// ----------------------------------------------------------------------

const LANGS = [
  {
    value: 'en',
    icon: '/assets/layer_2.png',
  },
];

// ----------------------------------------------------------------------

export default function LanguagePopover() {



  return (
    <>
      <IconButton
      disabled
        sx={{
          padding: 0,
          width: 160,
          height: 120,
        }}
      >
        <img src={LANGS[0].icon} alt={LANGS[0].label} />
      </IconButton>

      
    </>
  );
}
